// @flow
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import {
  MobileHiddenSpan,
  MobileOnlySpan
} from '../../../../components/ResponsiveHelpersStyles';
import { DefaultIcon } from '../../../../components/Icon';
import { TabH5 } from '../../../../components/ProgressTabStyles';

type Props = {
  active: boolean,
  index: number,
  label: string,
  shortLabel: string,
  valid: boolean,
  dirty: boolean
};

export default class ProgressTab extends Component<Props> {
  render() {
    const complete =
      this.props.valid && !(this.props.active && this.props.dirty);
    return (
      <NavLink to={`/merchants/registrations/form/${this.props.index}`}>
        <TabH5 active={this.props.active}>
          {complete && (
            <DefaultIcon
              name="checkmark"
              colorName={this.props.active ? 'black' : 'dustierGray'}
            />
          )}{' '}
          <MobileHiddenSpan>{this.props.label}</MobileHiddenSpan>
          <MobileOnlySpan>{this.props.shortLabel}</MobileOnlySpan>
        </TabH5>
      </NavLink>
    );
  }
}
